import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 91C2FA0C-2273-42F9-ACBF-BD418B8F970D
 * name label-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/label-outline.svg
 * tags
 */
export const LabelOutlineIcon = createSvgIcon(<><path d="M16,17H5V7H16L19.55,12M17.63,5.84C17.27,5.33 16.67,5 16,5H5A2,2 0 0,0 3,7V17A2,2 0 0,0 5,19H16C16.67,19 17.27,18.66 17.63,18.15L22,12L17.63,5.84Z" /></>, 'LabelOutlineIcon');
export default LabelOutlineIcon